import { styled } from '@mui/material';
import { TextField } from 'common/components/Inputs';

export const StyledTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    width: '2.5ch',
    height: 'auto',
  },
  '*::before, *::after': {
    borderBottom: 'none !important',
  },
});
